import { HardwareLoad } from "../demos/HardwareLoad";

export function HardwarePage() {
  return (
    <main className="wrap demo-page">
      <header className="demo-hero rise rise-1">
        <span className="eyebrow">Hardware load · real numbers</span>
        <h1>How hard does it actually work your machine?</h1>
        <p>
          A breakdown of where the time goes, from a ≈$150 mini-PC to a gaming
          rig. The fast gatekeeper runs constantly and is cheap everywhere; only
          the rare flagged frame pays for the accurate describer.
        </p>
      </header>

      <div className="rise rise-2">
        <HardwareLoad />
      </div>
    </main>
  );
}
